import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { EN_CALENDAR, ES_CALENDAR } from "common/utils/date"
import { withFormik } from "formik"
import { addLocale } from "primereact/api"
import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { setFechaVencimiento } from "../redux/slices/newDocumentoSlice"

const FechaVencimiento = ({
  values,
  handleSubmit,
  onHide,
  handleChange,
  isValid,
}: $TSMigrationFixMe) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  addLocale("es", ES_CALENDAR)
  addLocale("en", EN_CALENDAR)

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='tw-mb-2 tw-flex tw-flex-col'>
        <label htmlFor='calendar'>
          {t("crear.facturaRec.vencimientoDateLabel")}
        </label>
        <Calendar
          id='calendar'
          // @ts-expect-error TS(2769): No overload matches this call.
          autoFocus
          name='fechaVencimiento'
          value={values.fechaVencimiento}
          locale={language}
          dateFormat='dd/mm/yy'
          minDate={values.fechaEmision}
          mask='99/99/9999'
          onChange={handleChange}
          showIcon
          baseZIndex={2302}
        />
      </div>
      <div className='tw-mt-4 tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
        <ButtonPrimeReact
          className='tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          type='submit'
          disabled={!isValid}
          className='!tw-bg-primary tw-h-10 tw-flex tw-justify-center tw-items-center'
        >
          {t("crear.facturaRec.modal.addButton")}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  fechaVencimiento: Yup.string().min(3).required(),
})

const CreateWithFormik = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'fechaVencimiento' does not exist on type...
  mapPropsToValues: ({ fechaVencimiento, fechaEmision }) => ({
    fechaVencimiento: new Date(fechaVencimiento),
    fechaEmision: new Date(fechaEmision),
  }),
  handleSubmit: ({ fechaVencimiento }, { props }) => {
    // @ts-expect-error TS(2339): Property 'setfechaVencimiento' does not exist on t...
    props.setfechaVencimiento(fechaVencimiento)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(FechaVencimiento)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setfechaVencimiento: (fecha: $TSMigrationFixMe) =>
    dispatch(setFechaVencimiento(fecha)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  fechaVencimiento: newDocumentoSelector(state).fechaVencimiento,
  fechaEmision: newDocumentoSelector(state).fechaEmision,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
